import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

let refreshing = null;

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    const url = original?.url || "";
    const isAuthCall = url.includes("/auth/login") || url.includes("/auth/refresh") || url.includes("/auth/logout");
    if (error.response?.status === 401 && !isAuthCall && original && !original._retried) {
      original._retried = true;
      try {
        if (!refreshing) {
          refreshing = api.post("/auth/refresh").finally(() => { refreshing = null; });
        }
        await refreshing;
        return api(original);
      } catch {
        const path = window.location.pathname;
        const isPreview = window.location.hostname.includes("preview");
        // Preview hosts auto-sign-in via AuthContext — never hard-redirect there.
        if (!isPreview && path !== "/" && !path.startsWith("/site") && !path.startsWith("/login") && !path.startsWith("/share/") && !path.startsWith("/intake/") && !path.startsWith("/intake-start")
            && !path.startsWith("/train/") && !path.startsWith("/screen/") && !path.startsWith("/portal/")
            && !path.startsWith("/apply") && !path.startsWith("/reference-check/") && !path.startsWith("/offer/")
            && !path.startsWith("/interview/") && !path.startsWith("/documents/")
            && !path.startsWith("/free-care") && !path.startsWith("/chc") && !path.startsWith("/client-handbook") && !path.startsWith("/client-portal") && !path.startsWith("/forms") && !path.startsWith("/likeness/")) {
          window.location.href = "/login?from=" + encodeURIComponent(path);
        }
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).filter(Boolean).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
